'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TabContent = require('react-bootstrap/lib/TabContent');

var _TabContent2 = _interopRequireDefault(_TabContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TabContent2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/TabContent.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/TabContent.js
 ** module chunks = 0
 **/